import { Component, Input, OnInit } from "@angular/core";

import { ViewCell } from "ng2-smart-table";
import { STATUS } from "../../@core/data/default-list";

@Component({
  template: `<strong [ngClass]="renderCss" style="text-align: left;">
    {{ renderValue }}
  </strong>`,
})
export class StbCustomRenderStatusComponent implements ViewCell, OnInit {
  renderValue: string;
  renderCss: string;
  statusList = STATUS;

  @Input() value: number;
  @Input() rowData: any;

  ngOnInit() {
    this.renderValue = isNaN(this.value)
      ? this.statusList[0].title
      : this.statusList[this.value].title;
    this.renderCss = isNaN(this.value)
      ? "text-basic"
      : "text-" + this.statusList[this.value].status;
  }
}
